// @core/api/endpoints/task/list_tasks.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTasksResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List tasks
 * Returns a paginated list of tasks within a product. Supports filtering by status, assignee, priority, and other fields with flexible sorting options.
 */
export async function ListTasks(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTasksResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tasks`;
  const requestOptions = options;
  return client.get<ListTasksResponse>(requestPath, { ...requestOptions, params });
}
